import history from '../../util/history'

const toDetailTabView = (basePath, reservationId) => {
  history.replace(`${basePath}/${reservationId}/detail`)

  return true
}

export default toDetailTabView
